import { environment } from './environments/environment';

const cdnAssets = [
  environment.newRelicAsset,
  'https://dle-cdn.mheducation.com/mhe/tinymce/6.8.2/tinymce.min.js'
];

export default cdnAssets;
